import { render, staticRenderFns } from "./lazyblock_recipe.vue?vue&type=template&id=4d680c14&scoped=true"
import script from "./lazyblock_recipe.vue?vue&type=script&lang=js"
export * from "./lazyblock_recipe.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_recipe.vue?vue&type=style&index=0&id=4d680c14&prod&lang=scss&scoped=true"
import style1 from "./lazyblock_recipe.vue?vue&type=style&index=1&id=4d680c14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d680c14",
  null
  
)

export default component.exports